// =====================================================
// VITALSHOP MAIN JAVASCRIPT
// Compiled with Vite
// =====================================================

// Import jQuery (für WordPress-Kompatibilität)
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import bestehende JS-Module
import './js/main-functions';
import './js/cart';
import './js/product-filters';
import './js/country-autocomplete';
import './js/phone-validation';
import './js/utm-attribution';

// Import Third-Party Libraries
import 'intl-tel-input/build/css/intlTelInput.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Vite Hot Module Replacement
if (import.meta.hot) {
  import.meta.hot.accept();
}

if (import.meta.env.DEV) {
  import('./style.scss');
}

if (typeof window !== 'undefined') {
  window.__VS_BUILD_ID__ = 'main-' + (import.meta.glob ? Object.keys(import.meta.glob).length : Date.now());
  console.log('[VS] main bundle loaded:', window.__VS_BUILD_ID__);
}
